import { useAtomValue, useSetAtom } from 'jotai';

import { selectedBlockAtom, closePanelAtom } from '@/stores/panels';
import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { BlockDetailContent, BlockUpdateData } from './BlockDetailContent';
import { MissedReason, BlockWithRevisions } from '@/types';

interface BlockDetailPanelProps {
  onSave: (blockId: string, updates: BlockUpdateData) => Promise<boolean>;
  onDelete: (blockId: string) => Promise<boolean>;
  onMarkComplete: (blockId: string) => Promise<boolean>;
  onMarkMissed: (blockId: string, reason?: MissedReason) => Promise<boolean>;
  onDuplicate?: (block: BlockWithRevisions) => void;
}

export function BlockDetailPanel({
  onSave,
  onDelete,
  onMarkComplete,
  onMarkMissed,
  onDuplicate,
}: BlockDetailPanelProps) {
  const selectedBlock = useAtomValue(selectedBlockAtom);
  const closePanel = useSetAtom(closePanelAtom);
  const setSelectedBlock = useSetAtom(selectedBlockAtom);

  if (!selectedBlock) {
    return null;
  }

  return (
    <ResponsivePanelWrapper panelId="blockDetail" title="Block Details">
      <BlockDetailContent
        block={selectedBlock}
        onClose={() => {
          closePanel('blockDetail');
          setSelectedBlock(null);
        }}
        onSave={onSave}
        onDelete={onDelete}
        onMarkComplete={onMarkComplete}
        onMarkMissed={onMarkMissed}
        onDuplicate={onDuplicate}
      />
    </ResponsivePanelWrapper>
  );
}
